export class CreateExternalReportBrandingError extends Error{}